<template>
  <div style="height:40px;display:flex;justify-content: center;align-content: center;">

    <v-btn @click="changePageNumber(currPageNum-1)" v-show="currPageNum>1" outlined color="#E5E5E5" min-width="36" style="border-color:rgba(0,0,0,0.38);margin-top:2px;" class="px-0">
      <p style="font-size:14px;color:#888888;" class="iconfontFamily">&#xe617;</p>
    </v-btn>
    <p style="line-height:40px;" class="mx-3">{{currPageNum}}/{{totalPageNum}}</p>
    <v-btn @click="changePageNumber(currPageNum+1)" v-show="currPageNum<totalPageNum" outlined color="#E5E5E5" min-width="36" style="border-color:rgba(0,0,0,0.38);margin-top:2px;" class="px-0">
      <p style="font-size:14px;color:#888888;" class="iconfontFamily">&#xe61a;</p>
    </v-btn>
    <p style="line-height:40px;" class="ml-3">共{{totalPageNum}}页，转到</p>
    <v-select @change="changePageNumber(jumpToPageNum)" v-model="jumpToPageNum" :items="jumpToPageNumList"
              style="width:80px;height:36px;flex:none;" class="mx-3" dense outlined hide-details color="#A6A6A6">
    </v-select>
    <p style="line-height:40px;">页</p>

  </div>
</template>

<script>
export default {
  name: "PageNumber",
  props:["totalPageNum","currPageNum"],
  data(){
    return{

      jumpToPageNum:"",

    }
  },
  computed:{
    jumpToPageNumList(){
      let arr = [];
      for(let i=0;i<this.totalPageNum;i++){
        arr.push(i+1)
      }
      return arr;
    }
  },
  methods:{
    changePageNumber(number){
      this.$emit("changePageNumber",number)

    }


  }
}
</script>

<style scoped>

</style>